const AutoDRTypes = { 'oadr': 'OpenADR', 'ambi': 'Ambi Climate', 'future_point': 'FuturePoint' }
export default AutoDRTypes